import { reducers } from 'redux/core'
import request from 'sb-request'


const fetchOrders = () => {
  reducers.view.shippingAndBillingIssuesModal.setFetching(true)

  return request.post('graphql?name=profileShipments', {
    body: {
      query: `{
        profileShipments {
          year
          month
          shippingDate
          orderNo
          shipping {
           street
           apt
           city
           state
           zipCode
          }
          tracking {
            id
            number: trackingNumber
            url: trackingUrl
            status
          }
          products {
            id
            image
            brand
            url
            name
            upchargePrice
          }
          charge {
            chargeAmount
            createdDate
            paymentDate
          }
        }
      }`,
    },
    modifyResult: ({ profileShipments }) => profileShipments,
  })
    .then((items) => {
      reducers.view.shippingAndBillingIssuesModal.setOrders(items)
    })
}

export default {
  fetchOrders,
}
